import { formatReportValue } from "./dateFormat";

function escapeCsvValue(value, columnName = "") {
  if (value === null || value === undefined) return "";
  const text = String(formatReportValue(value, columnName));
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function addSerialNumberToCsv(csvText) {
  const source = String(csvText ?? "");
  const bom = source.startsWith("\uFEFF") ? "\uFEFF" : "";
  const text = bom ? source.slice(1) : source;
  const records = [];
  let record = [];
  let field = "";
  let quoted = false;

  for (let index = 0; index < text.length; index += 1) {
    const char = text[index];
    if (quoted) {
      if (char === '"' && text[index + 1] === '"') {
        field += '"';
        index += 1;
      } else if (char === '"') {
        quoted = false;
      } else {
        field += char;
      }
    } else if (char === '"') {
      quoted = true;
    } else if (char === ",") {
      record.push(field);
      field = "";
    } else if (char === "\n" || char === "\r") {
      record.push(field);
      records.push(record);
      record = [];
      field = "";
      if (char === "\r" && text[index + 1] === "\n") index += 1;
    } else {
      field += char;
    }
  }
  if (field !== "" || record.length || (text && !/[\r\n]$/.test(text))) {
    record.push(field);
    records.push(record);
  }
  if (!records.length) return source;
  const hasSerialNumber = String(records[0][0] || "").trim().toLowerCase() === "s.no";
  const headers = records[0];
  const escape = (value, columnName = "") => {
    const textValue = String(formatReportValue(value ?? "", columnName));
    return /[",\n\r]/.test(textValue) ? `"${textValue.replace(/"/g, '""')}"` : textValue;
  };
  const output = hasSerialNumber ? records : [["S.No", ...headers], ...records.slice(1).map((row, index) => [index + 1, ...row])];
  const outputHeaders = hasSerialNumber ? headers : ["S.No", ...headers];
  return bom + output.map((row, rowIndex) => row.map((value, columnIndex) => (
    rowIndex === 0 ? escape(value) : escape(value, outputHeaders[columnIndex])
  )).join(",")).join("\r\n");
}

export function downloadCsv(filename, columns, rows) {
  const hasSerialNumber = String(columns?.[0] || "").trim().toLowerCase() === "s.no";
  if (!hasSerialNumber) {
    columns = ["S.No", ...columns];
    rows = rows.map((row, index) => [index + 1, ...row]);
  }
  const csv = [
    columns.map((column) => escapeCsvValue(column)).join(","),
    ...rows.map((row) => row.map((value, index) => escapeCsvValue(value, columns[index])).join(",")),
  ].join("\r\n");

  const blob = new Blob(["\uFEFF", csv], {
    type: "text/csv;charset=utf-8;",
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();

  URL.revokeObjectURL(url);
}
